import * as React from 'react';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import { Icon, Button, Spin } from 'components/antd';
import AntModal, { ModalProps as AntModalProps } from 'antd/lib/modal';
import TitleNotice from './TitleNotice';
import { ThemeContext } from 'app-themes';

import styles from './Modal.module.scss';
export interface ModalProps extends AntModalProps {
	titleNotice?: string;
	specificBrowserTabTitle?: string;
	fixedFooter?: boolean;
	isWide?: boolean;
	isLoading?: boolean;
}

interface ModalState {
	isScrolling?: boolean;
}

class Modal extends React.Component<ModalProps, ModalState> {
	static contextType = ThemeContext;

	constructor(props: ModalProps) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll, true);

		// fix for IE zooming
		const htmlEl = document.getElementsByTagName('html')[0];
		if (htmlEl) {
			htmlEl.setAttribute('style', 'overflow: hidden');
		}
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll, true);

		// fix for IE zooming
		const htmlEl = document.getElementsByTagName('html')[0];
		if (htmlEl) {
			htmlEl.setAttribute('style', '');
		}
	}

	handleScroll = (e: any) => {
		if (e.target.classList && !e.target.classList.contains('ant-modal-wrap')) return;

		let scrollTop = e.srcElement.scrollTop;

		// scrollTop is set to undefined on zooming in IE
		if (scrollTop === 0 || scrollTop === undefined) {
			this.setState({
				isScrolling: false,
			});
		}

		if (scrollTop !== 0 && scrollTop !== undefined && !this.state.isScrolling) {
			this.setState({
				isScrolling: true,
			});
		}
	};

	closeModal = (e: React.MouseEvent) => {
		if (this.props.onCancel) {
			this.props.onCancel(e);
		}
	};

	getTitle = () => {
		const { titleNotice, title, specificBrowserTabTitle } = this.props;
		let pageTitle: React.ReactElement = specificBrowserTabTitle || (title as any);
		if (typeof pageTitle !== 'string') {
			pageTitle = pageTitle && pageTitle.props && pageTitle.props.children;
		}

		return (
			<>
				<Helmet>
					<title>{pageTitle}</title>
				</Helmet>
				<div
					className={classNames(styles.modalTitleInner, {
						[styles.modalTitleInnerWithNotice]: Boolean(titleNotice),
					})}
				>
					<h3>
						{title}
						{titleNotice && <TitleNotice text={titleNotice}></TitleNotice>}
					</h3>
					<Icon onClick={this.closeModal} type="close" />
				</div>
			</>
		);
	};

	getFooter = () => {
		const { onOk, onCancel, okText, okButtonProps = {}, footer, isLoading } = this.props;
		if (footer !== undefined) {
			return footer;
		}
		return (
			<div>
				<Button size="large" onClick={onCancel}>
					Cancel
				</Button>
				<Button
					size="large"
					type="primary"
					onClick={onOk}
					disabled={isLoading || okButtonProps.disabled}
				>
					{okText}
				</Button>
			</div>
		);
	};

	render() {
		const { fixedFooter, isWide, isLoading } = this.props;
		const theme = this.context;

		return (
			<AntModal
				{...this.props}
				title={this.getTitle()}
				closable={this.props.closable || false}
				wrapClassName={classNames(styles.wrapModal, {
					[styles[`wrapModal-${theme}`]]: theme !== '',
				})}
				mask={false}
				className={classNames(
					styles.modal,
					{ [styles.modalScrolled]: this.state.isScrolling },
					{ [styles.fixedFooter]: fixedFooter },
					{ [styles.isWide]: isWide },
					this.props.className
				)}
				footer={this.getFooter()}
			>
				<Spin spinning={isLoading || false}>{this.props.children}</Spin>
			</AntModal>
		);
	}
}

export default Modal;
